import React, { useEffect } from "react";
import styles from "./toast.module.scss";

interface ToastProps {
    variant: "error" | "success";
    message: string;
    duration?: number;
    onClose?: () => void;
    className?: string;
}

export const Toast: React.FC<ToastProps> = ({
    variant,
    message,
    duration = 5000,
    onClose,
    className,
}) => {
    useEffect(() => {
        if (!onClose) {
            return;
        }

        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [duration, onClose]);

    const classes = [styles["toast"], styles[variant], className]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={classes} role="status" aria-live="polite">
            <div className={styles["body"]}>
                <span className={styles["message"]}>{message}</span>

                {onClose && (
                    <button
                        type="button"
                        className={styles["close"]}
                        onClick={onClose}
                        aria-label="Fechar aviso"
                    >
                        ×
                    </button>
                )}
            </div>

            <span
                className={styles["timer"]}
                style={{ animationDuration: `${duration}ms` }}
            />
        </div>
    );
};

export default Toast;
